import {ErrorHandler, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EffectsModule} from '@ngrx/effects';
import {HTTP_INTERCEPTORS} from '@angular/common/http';

import {SharedRoutingModule} from './shared-routing.module';
import {PaginatorComponent} from './components/paginator/paginator.component';
import {AlertMessagesComponent} from './components/alert-messages/alert-messages.component';
import {LoaderComponent} from './components/loader/loader.component';
import {StoreModule} from '@ngrx/store';
import {ConstsHelper} from '../../helpers/consts.helper';
import {ApiService} from './services/api.service';
import {FileService} from './services/file.service';
import {loaderReducer} from './store/reducers/loader.reducer';
import {alertMessagesReducer} from './store/reducers/alert-messages.reducer';
import {selectedProcedureReducer} from './store/reducers/selected-procedure.reducer';
import {countriesReducer} from './store/reducers/countries.reducer';
import {changeFfersEligibleListReducer} from './store/reducers/change-ffers-eligible-list-reducer';
import {portabilityDatesReducer} from './store/reducers/portability-dates.reducer';
import {billGsmDetailsReducer} from './store/reducers/bill-gsm-details.reducer';
import {customerMsisdnNotificationsReducer} from './store/reducers/customer-msisdn-notifications.reducer';
import {checkPasswordReducer} from './store/reducers/check-password.reducer';
import {paginatorReducer} from './store/reducers/paginator.reducer';
import {simChoiceReducer} from './store/reducers/sim-choice.reducer';
import {mfaReducer} from './store/reducers/mfa.reducer';
import {HttpRequestInterceptor} from './services/http-request-interceptor';
import {GlobalErrorHandlerService} from './services/global-error-handler.service';
import {MenuComponent} from './components/menu/menu.component';
import {ProcedureCardComponent} from './components/procedure-card/procedure-card.component';
import {TerminateLineComponent} from './components/procedures/terminate-line/terminate-line.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MsisdnMissionService} from './services/msisdn-mission.service';
import {MissionEffects} from './store/effects/mission.effects';
import {ChangeOffersEligibleListEffects} from './store/effects/change-offers-eligible-list-effects';
import {PortabilityDatesEffects} from './store/effects/portability-dates.effects';
import {ChangeNetworkComponent} from './components/procedures/change-network/change-network.component';
import {ChangeOfferComponent} from './components/procedures/change-offer/change-offer.component';
import {OfferVitrineService} from './services/offer-vitrine.service';
import {IdentifyLineComponent} from './components/procedures/identify-line/identify-line.component';
import {InsuranceComponent} from './components/procedures/insurance/insurance.component';
import {SurtaxNumberComponent} from './components/procedures/surtax-number/surtax-number.component';
import {MultimediaPurchaseComponent} from './components/procedures/multimedia-purchase/multimedia-purchase.component';
import {CorrespondentsOptionsComponent} from './components/procedures/correspondents-options/correspondents-options.component';
import {ThreeWayConferenceComponent} from './components/procedures/three-way-conference/three-way-conference.component';
import {VisualMessagingComponent} from './components/procedures/visual-messaging/visual-messaging.component';
import {RechargeDataComponent} from './components/procedures/recharge-data/recharge-data.component';
import {RechargeVoiceComponent} from './components/procedures/recharge-voice/recharge-voice.component';
import {AddressCardComponent} from './components/address-card/address-card.component';
import {OrderSimCardComponent} from './components/procedures/order-sim-card/order-sim-card.component';
import {PortabilityDatesService} from './services/portability-dates.service';
import {NotReceivedSimCardComponent} from './components/procedures/not-received-sim-card/not-received-sim-card.component';
import {LossStealComponent} from './components/procedures/loss-steal/loss-steal.component';
import {ActivateSimCardComponent} from './components/procedures/activate-sim-card/activate-sim-card.component';
import {VoiceCallAssistanceComponent} from './components/procedures/voice-call-assistance/voice-call-assistance.component';
import {CountryService} from './services/country.service';
import {CountriesEffects} from './store/effects/countries.effects';
import {MmsAssistanceComponent} from './components/procedures/mms-assistance/mms-assistance.component';
import {NotificationsComponent} from './components/notifications/notifications.component';
import {NotificationService} from './services/notification.service';
import {NotificationsEffects} from './store/effects/notifications.effects';
import {BillProtestComponent} from './components/procedures/bill-protest/bill-protest.component';
import {CustomerMissionService} from './services/customer-mission.service';
import {CustomerMissionEffects} from './store/effects/customer-mission.effects';
import {BillGsmDetailsEffects} from './store/effects/bill-gsm-details.effects';
import {AccountConsolidationComponent} from './components/procedures/account-consolidation/account-consolidation.component';
import {CheckPasswordComponent} from './components/check-password/check-password.component';
import {ActivationFiveGComponent} from './components/procedures/activation-five-g/activation-five-g.component';
import {VitrineMenuComponent} from './components/vitrine-menu/vitrine-menu.component';
import {VitrineFooterComponent} from './components/vitrine-footer/vitrine-footer.component';
import {ShuntersComponent} from './components/shunters/shunters.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {DateAdapter, MAT_DATE_LOCALE, MatNativeDateModule} from '@angular/material/core';
import {MatIconModule} from '@angular/material/icon';
import {DotComponent} from './components/dot/dot.component';
import {CancelTerminateLineComponent} from './components/procedures/cancel-terminate-line/cancel-terminate-line.component';
import {CustomDateAdapter} from '../../helpers/custom-date-adapter';
import {PartnerPaymentService} from './services/partner-payment.service';
import {BreadcrumbComponent} from './components/breadcrumb/breadcrumb.component';
import {PriceFormatService} from './services/price-format.service';
import {FrequentlyQuestionsComponent} from './components/frequently-questions/frequently-questions.component';
import {CancelSimOrderComponent} from './components/procedures/cancel-sim-order/cancel-sim-order.component';
import {DimeloService} from './services/dimelo.service';
import { CancelChangeOfferComponent } from './components/procedures/cancel-change-offer/cancel-change-offer.component';
import { CancelChangeNetworkComponent } from './components/procedures/cancel-change-network/cancel-change-network.component';
import { NotifBellComponent } from './components/notif-bell/notif-bell.component';
import { CancelLossStealComponent } from './components/procedures/cancel-loss-steal/cancel-loss-steal.component';
import { GenerateSepaMandateComponent } from './components/procedures/generate-sepa-mandate/generate-sepa-mandate.component';
import { PaymentFormComponent } from './components/payment-form/payment-form.component';
import { CreditAccountComponent } from './components/procedures/credit-account/credit-account.component';
import { PaymentExpressComponent } from './components/procedures/payment-express/payment-express.component';
import { UnblockLineComponent } from './components/procedures/unblock-line/unblock-line.component';
import { CustomerReportingService } from './services/customer-reporting.service';
import { CryptService } from './services/crypt.service';
import { ExtranetService } from './services/extranet.service';
import { ChangeFinalBillingDateComponent } from './components/procedures/change-final-billing-date/change-final-billing-date.component';
import { TechnicalAssistanceComponent } from './components/procedures/technical-assistance/technical-assistance.component';
import { SimChoiceComponent } from './components/sim-choice/sim-choice.component';
import { EsimQrCodeComponent } from './components/esim-qr-code/esim-qr-code.component';
import { EsimService } from './services/esim.service';
import { NotReceivedPaymentComponent } from './components/procedures/not-received-payment/not-received-payment.component';
import { MfaPopupComponent } from './components/mfa-popup/mfa-popup.component';
import { MfaService } from './services/mfa.service';
import { IaChatWebComponent } from './components/ia-chat-web/ia-chat-web.component';
import { MessageBoardComponent } from './components/message-board/message-board.component';
import { RetractionComponent } from './components/procedures/retraction/retraction.component';
import { displayIaChatbotReducer } from './store/reducers/display-ia-chatbot.reducer';
import { LandlineMissionService } from './services/landline-mission.service';
import { LandlineMissionEffects } from './store/effects/landline-mission.effects';
import { VitrineMenuCoriolisComponent } from './components/vitrine-menu-coriolis/vitrine-menu-coriolis.component';
import { VitrineFooterCoriolisComponent } from './components/vitrine-footer-coriolis/vitrine-footer-coriolis.component';
import { VadSubscriptionService } from './services/vad-subscription.service';
import { EgelirrKoComponent } from './components/procedures/egelirr-ko/egelirr-ko.component';
import { ChangeOfferMefComponent } from './components/procedures/change-offer-mef/change-offer-mef.component';
import { ProFleetModalComponent } from './components/pro-fleet-modal/pro-fleet-modal.component';
import { ProFleetService } from './services/pro-fleet.service';
import { ModifyAppointmentComponent } from './components/procedures/modify-appointment/modify-appointment.component';
import { TechnicalAssistanceService } from './services/technical-assistance.service';
import { ExportBillingStatusComponent } from './components/procedures/export-billing-status/export-billing-status.component';
import { RechargeDataPrixtelComponent } from './components/procedures/recharge-data-prixtel/recharge-data-prixtel.component';
import { RechargeDataCoriolisComponent } from './components/procedures/recharge-data-coriolis/recharge-data-coriolis.component';
import { ActivateNewSimCardComponent } from './components/procedures/activate-new-sim-card/activate-new-sim-card.component';
import { HandleLineOptionsComponent } from './components/procedures/handle-line-options/handle-line-options.component';
import { NotesPopupComponent } from './components/notes-popup/notes-popup.component';
import { NotesService } from './services/notes.service';
import { ToggleSmsInternetPlusComponent } from './components/procedures/toggle-sms-internet-plus/toggle-sms-internet-plus.component';
import { RefillOrPassComponent } from './components/procedures/refill-or-pass/refill-or-pass.component';
import { CommunicationDetailComponent } from './components/procedures/communication-detail/communication-detail.component';
import { CustomerRgpdComponent } from './components/procedures/customer-rgpd/customer-rgpd.component';
import { SponsorshipService } from './services/sponsorship.service';
import { SponsoredListEffects } from './store/effects/sponsored-list.effects';
import { ConsumptionsDetailsComponent } from './components/procedures/consumptions-details/consumptions-details.component';
import { DeactivateOptionsComponent } from './components/procedures/deactivate-options/deactivate-options.component';
import { ChangeOfferToBasePrepaidComponent } from './components/procedures/change-offer-to-base-prepaid/change-offer-to-base-prepaid.component';
import { SignatoriesManagementComponent } from './components/procedures/signatories-management/signatories-management.component';
import { ViesStatusComponent } from './components/vies-status/vies-status.component';
import { TowGService } from './services/tow-g.service';

export const httpInterceptorProviders = [
    {
        provide: HTTP_INTERCEPTORS,
        useClass: HttpRequestInterceptor,
        multi: true
    }
];

@NgModule({
    declarations: [
        PaginatorComponent,
        AlertMessagesComponent,
        LoaderComponent,
        MenuComponent,
        ProcedureCardComponent,
        TerminateLineComponent,
        ChangeNetworkComponent,
        ChangeOfferComponent,
        IdentifyLineComponent,
        InsuranceComponent,
        SurtaxNumberComponent,
        MultimediaPurchaseComponent,
        CorrespondentsOptionsComponent,
        ThreeWayConferenceComponent,
        VisualMessagingComponent,
        RechargeDataComponent,
        RechargeVoiceComponent,
        AddressCardComponent,
        OrderSimCardComponent,
        NotReceivedSimCardComponent,
        LossStealComponent,
        ActivateSimCardComponent,
        VoiceCallAssistanceComponent,
        MmsAssistanceComponent,
        NotificationsComponent,
        BillProtestComponent,
        AccountConsolidationComponent,
        CheckPasswordComponent,
        ActivationFiveGComponent,
        VitrineMenuComponent,
        VitrineFooterComponent,
        DotComponent,
        ShuntersComponent,
        CancelTerminateLineComponent,
        BreadcrumbComponent,
        FrequentlyQuestionsComponent,
        CancelSimOrderComponent,
        CancelChangeOfferComponent,
        CancelChangeNetworkComponent,
        NotifBellComponent,
        CancelLossStealComponent,
        GenerateSepaMandateComponent,
        ChangeFinalBillingDateComponent,
        PaymentFormComponent,
        CreditAccountComponent,
        PaymentExpressComponent,
        UnblockLineComponent,
        TechnicalAssistanceComponent,
        SimChoiceComponent,
        EsimQrCodeComponent,
        NotReceivedPaymentComponent,
        MfaPopupComponent,
        IaChatWebComponent,
        MessageBoardComponent,
        RetractionComponent,
        VitrineMenuCoriolisComponent,
        VitrineFooterCoriolisComponent,
        EgelirrKoComponent,
        ChangeOfferMefComponent,
        ProFleetModalComponent,
        ModifyAppointmentComponent,
        ExportBillingStatusComponent,
        RechargeDataPrixtelComponent,
        RechargeDataCoriolisComponent,
        ActivateNewSimCardComponent,
        HandleLineOptionsComponent,
        NotesPopupComponent,
        ToggleSmsInternetPlusComponent,
        RefillOrPassComponent,
        CommunicationDetailComponent,
        CustomerRgpdComponent,
        ConsumptionsDetailsComponent,
        DeactivateOptionsComponent,
        ChangeOfferToBasePrepaidComponent,
        SignatoriesManagementComponent,
        ViesStatusComponent,
    ],
    exports: [
        PaginatorComponent,
        AlertMessagesComponent,
        EsimQrCodeComponent,
        LoaderComponent,
        MenuComponent,
        ProcedureCardComponent,
        TerminateLineComponent,
        ChangeNetworkComponent,
        ChangeOfferComponent,
        IdentifyLineComponent,
        InsuranceComponent,
        MultimediaPurchaseComponent,
        SurtaxNumberComponent,
        CorrespondentsOptionsComponent,
        ThreeWayConferenceComponent,
        VisualMessagingComponent,
        RechargeDataComponent,
        RechargeVoiceComponent,
        AddressCardComponent,
        OrderSimCardComponent,
        NotReceivedSimCardComponent,
        LossStealComponent,
        ActivateSimCardComponent,
        VoiceCallAssistanceComponent,
        MmsAssistanceComponent,
        NotificationsComponent,
        BillProtestComponent,
        AccountConsolidationComponent,
        CheckPasswordComponent,
        ActivationFiveGComponent,
        VitrineMenuComponent,
        VitrineFooterComponent,
        DotComponent,
        ShuntersComponent,
        CancelTerminateLineComponent,
        BreadcrumbComponent,
        FrequentlyQuestionsComponent,
        CancelSimOrderComponent,
        CancelChangeOfferComponent,
        CancelChangeNetworkComponent,
        NotifBellComponent,
        CancelLossStealComponent,
        GenerateSepaMandateComponent,
        ChangeFinalBillingDateComponent,
        PaymentFormComponent,
        CreditAccountComponent,
        PaymentExpressComponent,
        UnblockLineComponent,
        TechnicalAssistanceComponent,
        SimChoiceComponent,
        NotReceivedPaymentComponent,
        MfaPopupComponent,
        IaChatWebComponent,
        MessageBoardComponent,
        RetractionComponent,
        VitrineMenuCoriolisComponent,
        VitrineFooterCoriolisComponent,
        EgelirrKoComponent,
        ChangeOfferMefComponent,
        ProFleetModalComponent,
        ModifyAppointmentComponent,
        ExportBillingStatusComponent,
        ActivateNewSimCardComponent,
        HandleLineOptionsComponent,
        NotesPopupComponent,
        ToggleSmsInternetPlusComponent,
        RefillOrPassComponent,
        CommunicationDetailComponent,
        CustomerRgpdComponent,
        ConsumptionsDetailsComponent,
        DeactivateOptionsComponent,
        ChangeOfferToBasePrepaidComponent,
        SignatoriesManagementComponent,
        ViesStatusComponent
    ],
    imports: [
        ReactiveFormsModule,
        CommonModule,
        SharedRoutingModule,
        StoreModule.forFeature(ConstsHelper.REDUCER_LOADER, loaderReducer),
        StoreModule.forFeature(ConstsHelper.REDUCER_ALERT_MESSAGES, alertMessagesReducer),
        StoreModule.forFeature(ConstsHelper.REDUCER_SELECTED_PROCEDURE, selectedProcedureReducer),
        StoreModule.forFeature(ConstsHelper.REDUCER_CHANGE_OFFERS_ELIGIBLE_LIST, changeFfersEligibleListReducer),
        StoreModule.forFeature(ConstsHelper.REDUCER_PORTABILITY_DATES, portabilityDatesReducer),
        StoreModule.forFeature(ConstsHelper.REDUCER_COUNTRIES, countriesReducer),
        StoreModule.forFeature(ConstsHelper.REDUCER_CUSTOMER_MSISDN_NOTIFICATIONS, customerMsisdnNotificationsReducer),
        StoreModule.forFeature(ConstsHelper.REDUCER_PAGINATOR, paginatorReducer),
        StoreModule.forFeature(ConstsHelper.REDUCER_BILL_GSM_DETAILS, billGsmDetailsReducer),
        StoreModule.forFeature(ConstsHelper.REDUCER_CHECK_PASSWORD, checkPasswordReducer),
        StoreModule.forFeature(ConstsHelper.REDUCER_SIM_CHOICE, simChoiceReducer),
        StoreModule.forFeature(ConstsHelper.REDUCER_MFA, mfaReducer),
        StoreModule.forFeature(ConstsHelper.REDUCER_DISPLAY_IA_CHATBOT, displayIaChatbotReducer),
        EffectsModule.forRoot(
            [
                MissionEffects,
                ChangeOffersEligibleListEffects,
                PortabilityDatesEffects,
                CountriesEffects,
                NotificationsEffects,
                CustomerMissionEffects,
                BillGsmDetailsEffects,
                LandlineMissionEffects,
                SponsoredListEffects
            ]
        ),
        FormsModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatNativeDateModule,
        MatInputModule,
        MatIconModule,
    ],
    providers: [
        ApiService,
        MsisdnMissionService,
        OfferVitrineService,
        CountryService,
        DimeloService,
        NotificationService,
        FileService,
        PortabilityDatesService,
        CustomerMissionService,
        PartnerPaymentService,
        PriceFormatService,
        CustomerReportingService,
        StoreModule,
        CryptService,
        ExtranetService,
        EsimService,
        MfaService,
        ProFleetService,
        LandlineMissionService,
        VadSubscriptionService,
        TechnicalAssistanceService,
        NotesService,
        SponsorshipService,
        TowGService,
        httpInterceptorProviders,
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandlerService
        },
        {provide: MAT_DATE_LOCALE, useValue: 'fr-FR'},
        {provide: DateAdapter, useClass: CustomDateAdapter},
    ],
})
export class SharedModule {
}
